// src/composables/useNumberFormat.ts

import { computed } from 'vue'
import type { NumberFormatOptions } from '~/protos/gen/stcs_user.entity'
import { useCtxStore } from '~/stores/ctx.store'
import { default_user_number_format_settings } from '~/types/app-settings'

/**
 * Composable to access org-specific number formatting settings (per user, per org).
 * Returns the current user's number format settings for the selected organization.
 * Settings are consistent across all companies within the same org.
 * Falls back to default settings if not configured.
 *
 * @returns Computed ref containing NumberFormatOptions
 */
export function useNumberFormat() {
  const ctxStore = useCtxStore()

  return computed<NumberFormatOptions>(() => {
    // Get current user's org-specific settings (stored at org level, not per company)
    const userOrgSettings = ctxStore.getCurrentUserOrgSettings()
    const numberFormat = userOrgSettings?.number_format

    // Return user's org-specific settings or fall back to defaults
    return numberFormat || default_user_number_format_settings
  })
}
